import React from "react";
import PageShell from "../components/PageShell";

function ImpressumPage() {
  return (
    <PageShell maxWidth="max-w-3xl">
        <section className="rounded-2xl border border-[#dce8c8] bg-white p-6 shadow-sm sm:p-8">
          <p className="mb-3 text-xs font-medium uppercase tracking-[0.22em] text-neutral-500">Rechtliches</p>
          <h1 className="text-3xl font-semibold tracking-[-0.04em]">Impressum</h1>

          <div className="mt-8 space-y-6 text-sm leading-7 text-neutral-700">
            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">Angaben gemäß § 5 DDG</h2>
              <p>
                Jan Peters<br />
                Rönneter 205<br />
                41068 Mönchengladbach<br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">Kontakt</h2>
              <p>
                E-Mail: kontakt@jape-dev.de
              </p>
            </section>

            <section>
              <h2 className="mb-2 text-lg font-semibold text-neutral-950">Verantwortlich für den Inhalt</h2>
              <p>
                Jan Peters<br />
                Rönneter 205<br />
                41068 Mönchengladbach<br />
                Deutschland
              </p>
            </section>
          </div>
        </section>
    </PageShell>
  );
}

export default ImpressumPage;
